import { component as defineComponent } from 'flightjs';
import { find } from 'lodash';

export default defineComponent(function () {
    this.attributes({
        'input': '[data-filter-toggle-input]',
        'button': '[data-filter-toggle-button]',
        'filterNameAttr': 'data-toggle-value-filter'
    });

    this.after('initialize', function () {
        this.on('click', {
            button: this.triggerFilterChange
        });

        this.on(document, 'uiBrowseFiltersUpdated', this.updateDisplay);
    });

    this.isButtonSelected = function ($button) {
        return $button.is('[data-button-selected]');
    };

    this.isButtonDisabled = function ($button) {
        return $button.is('[data-button-disabled]');
    };

    this.isButtonDeselectable = function ($button) {
        return $button.is('[data-filter-toggle-button-deselectable]');
    };

    this.deselectButton = function ($button) {
        $button.removeAttr('data-button-selected');
        $button.find(this.attr.input).prop('checked', false);
    };

    this.selectButton = function ($button) {
        $button.attr('data-button-selected', true);
        $button.find(this.attr.input).prop('checked', true);
        this.$node.data('selectedValue', $button.find(this.attr.input).val());
    };

    this.deselectAll = function () {
        this.select('button').each(function (idx, button) {
            this.deselectButton($(button));
        }.bind(this));
        this.$node.data('selectedValue', null);
    };

    this.toggleButton = function ($button) {
        var toBeSelect = !this.isButtonSelected($button);
        this.deselectAll();

        if (toBeSelect) {
            this.selectButton($button);
        }
    };

    this.selectButtonByValue = function (value) {
        return find(this.select('button'), function (el) {
            return $(el).attr('data-filter-toggle-button') === value;
        });
    };

    this.triggerFilterChange = function (e) {
        var $button = $(e.currentTarget);
        var isSelected = this.isButtonSelected($button);
        var isDisabled = this.isButtonDisabled($button);
        var isDeselectable = this.isButtonDeselectable($button);
        var fieldName = this.$node.attr(this.attr.filterNameAttr);
        var payload = {};

        if (!isDisabled && (!isSelected || isDeselectable)) {
            this.toggleButton($button);
            payload[fieldName] = this.$node.data('selectedValue');
            this.trigger('uiBrowseFiltersUpdated', payload);
        }
    };

    this.updateDisplay = function (e, data) {
        var field = this.$node.attr(this.attr.filterNameAttr);

        if (data.hasOwnProperty(field)) {
            var newValue = data[field], buttonToSelect;

            if (this.$node.data('selectedValue') !== newValue) {
                this.deselectAll();
                buttonToSelect = this.selectButtonByValue(newValue);
                if (buttonToSelect) {
                    this.selectButton($(buttonToSelect));
                }
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/toggle-value-filter.js